import { Modal } from "components/modal/modal";
import React, { useEffect } from "react";
import {
  KelasLiveFeatures,
  KelasLiveFeaturesContainer,
  KelasLiveFeaturesDesc,
  KelasLiveFeaturesHeading,
  KelasLiveFeaturesImage,
  KelasLiveFeaturesTitle,
  TrialActivationSubTitle,
  TrialActivationTitle,
  TrialActivationWrapper
} from "./trial-activation-modal.styles";
import { theme } from "styles";
import { Spacer } from "styles/common/spacer";
import { KelasLiveFeaturesData } from "./trial-activation-modal.data";
import { KelasLiveCTABlockButton } from "../kelas-live-cta-block/kelas-live-cta-block.styles";
import { ITrialActivationMessage } from "./trial-activation-modal.types";
import trackEvent from "services/mixpanel/mixpanel";
import { eventNames } from "services/mixpanel/events";
import { useKelasLiveContext } from "stores/kelas-live/kelas-live-context";

const TrialActivationMessage: React.FC<ITrialActivationMessage> = ({
  onClose,
  activateTrial
}) => {
  const displayProperties = {
    backgroundColor: theme.colors.brand[700]
  };
  const closeIconProperties = {
    color: theme.colors.white
  };
  const handleActivateTrial = () => {
    activateTrial();
  };
  const {
    user: { isUserLoggedIn }
  } = useKelasLiveContext();

  useEffect(() => {
    trackEvent({
      eventName: eventNames.trialConfirmationPageViewed,
      payload: {
        isUserLoggedIn
      }
    });
  }, []);
  const {
    userSubscription: { subscriptionStatus }
  } = useKelasLiveContext();
  const trialDuration = subscriptionStatus && subscriptionStatus.daysLeft;

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      displayProperties={displayProperties}
      closeIconProperties={closeIconProperties}>
      <TrialActivationWrapper>
        <TrialActivationTitle>
          Aktifin Kelas Live gratis selama {trialDuration} hari!
        </TrialActivationTitle>
        <Spacer token={[8, 8, 8]} />
        <TrialActivationSubTitle>
          Jadi bagian dari komunitas belajar paling suportif se-Indonesia.
        </TrialActivationSubTitle>
        <Spacer token={[8, 8, 8]} />
        <KelasLiveFeaturesHeading>
          Kenapa ikutan Kelas Live?
        </KelasLiveFeaturesHeading>
        <KelasLiveFeaturesContainer>
          {KelasLiveFeaturesData.map((feature) => (
            <KelasLiveFeatures key={feature.title}>
              <KelasLiveFeaturesImage>
                <feature.imgSrc />
              </KelasLiveFeaturesImage>
              <KelasLiveFeaturesTitle>{feature.title}</KelasLiveFeaturesTitle>
              <KelasLiveFeaturesDesc>{feature.desc}</KelasLiveFeaturesDesc>
            </KelasLiveFeatures>
          ))}
        </KelasLiveFeaturesContainer>
        <KelasLiveCTABlockButton onClick={handleActivateTrial}>
          Aktifin coba gratis
        </KelasLiveCTABlockButton>
      </TrialActivationWrapper>
    </Modal>
  );
};
export { TrialActivationMessage };
